module.exports = __webpack_public_path__ + "static/media/FAQ.d29fdb23.png";